import * as Yup from 'yup';

const requiredText = () => Yup.string().trim().required('Required');

export const medicalValidationSchema = () =>
  Yup.object({
    medicalDetails: Yup.object({
      class: requiredText(),
      level: requiredText(),
      nssf: requiredText(),
      covers: Yup.array()
        .of(
          Yup.object({
            coverID: requiredText(),
            isMandatory: Yup.boolean()
          })
        )
        .required('Required')
    })
  });
